import { mount } from './dom-lifecycle';

mount('[data-content-input]', function () {
    const $input = $(this);
    const $counter = $input.closest('form').find('[data-content-counter]');
    const update = () => $counter.text($input.val().length);
    $input.on('input', update);
    update();
});
